<template>
	<v-dialog v-model="showDialog">
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">差戻しメッセージ作成</v-app-bar-title>
				<v-spacer />
				<v-btn icon color="white" dark @click="closeDialog()" large
					><v-icon>mdi-close</v-icon></v-btn
				>
			</v-app-bar>
			<v-form ref="form" class="form" lazy-validation>
				<v-container>
					<p v-if="requirement.requirement_type">{{ requirement.requirement_type.name }}</p>
					<v-textarea
						class="mt-4"
						:hint="
							message
								? '依頼作成者にメッセージの内容が送信されます'
								: '差戻し理由を記入してください'
						"
						:rules="[rules.required]"
						ref="textarea"
						v-model="message"
						label="差戻し理由(必須)"
						required
						outlined
						dense
					/>
				</v-container>
				<v-card-actions>
					<v-row no-gutters justify="center">
						<v-btn color="secondary" :disabled="!isValid" @click="submitMessage(requirement.id)"
							>送信する</v-btn
						>
					</v-row>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		requirement: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			rules: rules,
			message: "",
		}
	},
	methods: {
		closeDialog() {
			this.$refs.form.reset()
			this.showDialog = false
		},
		submitMessage(requirement_id) {
			const params = {
				message: this.message,
				requirement_type_id: this.requirement.requirement_type.id,
				requirement_user_id: this.requirement.user_id,
			}

			this.$emit("submitMessage", requirement_id, params)
			this.closeDialog()
		},
		isPresence(value) {
			return value !== null && value !== ""
		},
	},
	computed: {
		isValid() {
			return this.isPresence(this.message)
		},
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>
